// Libraries
import React from "react";
import { connect } from 'react-redux';

// Local Libraries
import { gisRoutes } from "../../routes/routes";
import * as token from "../../helpers/token"
import { supportedLanguages } from "../../i18n/supported-languages";
import phrasebookLoad from "../../i18n";
import { accountTypesConstants } from '../../constants';
import { capitalizeFirstLetter } from "../../helpers/util"


// Redux
import { accountActions, georesourceActions } from 'actions';
import { userStorage } from '../../helpers/user-storage';

// Components
import { SubmitButton, CancelButton } from "../../components/SkyFramework/Buttons";
import { Form } from "../../components/SkyFramework/Forms";
import { NewBreadcrumbs } from "../../components/SkyFramework/Breadcrumbs/NewBreadcrumbs";
import { Modal, ModalButton } from '../../components/SkyFramework/Modal'


// Constants
const languageOptions = supportedLanguages.map(function (lang) {
  return { value: lang['code'], label: lang['language'] };
});
const phrasebook = phrasebookLoad()


class UserProfile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      username: undefined,
      email: undefined,
      account_type_id: undefined,
      firstname: undefined,
      lastname: undefined,
      telephone: undefined,
      mobile: undefined,
      fax: undefined,
      jobtitle: undefined,
      language: undefined,
      address_country: undefined,
      address_city: undefined,
      address_line_1: undefined,
      address_line_2: undefined,
      address_line_3: undefined,
      address_postcode: undefined,
      delete_password: undefined,

      currency: undefined,
      currencies: undefined,
      submitted: false
    }

    this.account_type_logged = accountTypesConstants[token.loggedAccountType()];
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDelete = this.handleDelete.bind(this);

  }

  componentDidMount() {
    // this.props.dispatch(accountActions.getAll());
    // this.props.dispatch(customerActions.getAll());
    this.props.dispatch(georesourceActions.getCurrencies(undefined, 250, 0));
    if (userStorage.hasUser())
      this.props.dispatch(accountActions.getProfile());
  }

  componentDidUpdate(prevProps) {
    // if (this.props.customers && prevProps && prevProps.customers !== this.props.customers) {
    //   this.setState({ customers: this.props.customers });
    // }
    // if (this.props.account_types && prevProps && prevProps.account_types !== this.props.account_types) {
    //   this.setState({ account_types: this.props.account_types });
    // }
    if (this.props.currencies && prevProps && prevProps.currencies !== this.props.currencies) {
      this.setState({ currencies: this.props.currencies });
    }

    if (this.props.userprofile && prevProps && prevProps.userprofile !== this.props.userprofile) {
      this.setState({
        username: this.props.userprofile.username,
        account_type_id: this.props.userprofile.account_type_id,
        email: this.props.userprofile.email,
        firstname: this.props.userprofile.userprofile.firstname,
        lastname: this.props.userprofile.userprofile.lastname,
        telephone: this.props.userprofile.userprofile.telephone,
        mobile: this.props.userprofile.userprofile.mobile,
        fax: this.props.userprofile.userprofile.fax,
        jobtitle: this.props.userprofile.userprofile.jobtitle,
        language: this.props.userprofile.userprofile.language,
        address_country: this.props.userprofile.userprofile.address_country,
        address_city: this.props.userprofile.userprofile.address_city,
        address_line_1: this.props.userprofile.userprofile.address_line_1,
        address_line_2: this.props.userprofile.userprofile.address_line_2,
        address_line_3: this.props.userprofile.userprofile.address_line_3,
        address_postcode: this.props.userprofile.userprofile.address_postcode,
        // account_type_id: this.props.user.account_type_id,
        // customer_id: this.props.user.customer_id,
        currency: this.props.userprofile.userprofile.currency,
        submitted: false
      });
    }
  }

  handleChange(e) {
    const { id, name, value } = e.target;
    if (id) this.setState({ [id]: value });
    else if (name) this.setState({ [name]: value });
  }

  handleDelete(e) {
    e.preventDefault();

    this.props.dispatch(accountActions.deleteOwnAccount(this.state.delete_password));
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });
    var updatedValues = {
      username: this.state.username,
      firstname: this.state.firstname,
      lastname: this.state.lastname,
      jobtitle: this.state.jobtitle,
      email: this.state.email,
      telephone: this.state.telephone,
      mobile: this.state.mobile,
      fax: this.state.fax,
      language: this.state.language,
      address_country: this.state.address_country,
      address_city: this.state.address_city,
      address_line_1: this.state.address_line_1,
      address_line_2: this.state.address_line_2,
      address_line_3: this.state.address_line_3,
      address_postcode: this.state.address_postcode,
      // account_type_id: this.state.account_type_id,
      // customer_id: this.state.customer_id,
      currency: this.state.currency
    }
    if (userStorage.hasUser())
      this.props.dispatch(accountActions.updateProfile(updatedValues));
    // this.componentDidMount();
  }

  FormProfile = () => {
    // this.state.account_types && this.state.customers &&
    if (this.state.currencies && this.state.username) {

      // const accountOptions = this.state.account_types.account_types.map(function (account_type) {
      //   return { value: account_type['id'], label: capitalizeFirstLetter(account_type['account_type']) };
      // });
      // const customerOptions = this.state.customers.customers.map(function (customer) {
      //   return { value: customer['id'], label: capitalizeFirstLetter(customer['name']) };
      // });
      const currencyOptions = this.state.currencies.data.map(function (currency) {
        return { value: currency['code'], label: capitalizeFirstLetter(currency['name']) };
      });


      const inputs = [
        // { label: phrasebook.profile.account_type, type: "select", id: "account_type_id", name: "account_type_id", options: accountOptions, empty_option: true, selected: this.state.account_type_id },
        // { label: phrasebook.common.customer, type: "select", id: "customer_id", name: "customer_id", options: customerOptions, empty_option: true, selected: this.state.customer_id, disabled: true },
        { label: phrasebook.profile.username, type: "text", placeholder: this.state.username, id: "username", name: "username", value: this.state.username },
        { label: phrasebook.profile.account_type, type: "text", placeholder: this.state.account_type_id, id: "account_type_id", name: "account_type_id", value: phrasebook.accounts[accountTypesConstants[this.state.account_type_id]], disabled: true },
        { label: phrasebook.profile.email, type: "text", placeholder: this.state.email, id: "email", name: "email", value: this.state.email },

        { label: phrasebook.profile.firstname, type: "text", placeholder: this.state.firstname, id: "firstname", name: "firstname", value: this.state.firstname },
        { label: phrasebook.profile.lastname, type: "text", placeholder: this.state.lastname, id: "lastname", name: "lastname", value: this.state.lastname },

        { label: phrasebook.profile.jobtitle, type: "text", placeholder: this.state.jobtitle, id: "jobtitle", name: "jobtitle", value: this.state.jobtitle },

        { label: phrasebook.profile.telephone, type: "text", placeholder: this.state.telephone, id: "telephone", name: "telephone", value: this.state.telephone },
        { label: phrasebook.profile.mobile, type: "text", placeholder: this.state.mobile, id: "mobile", name: "mobile", value: this.state.mobile },
        { label: phrasebook.profile.fax, type: "text", placeholder: this.state.fax, id: "fax", name: "fax", value: this.state.fax },
        { label: phrasebook.references.currency, type: "select", id: "currency", name: "currency", options: currencyOptions, empty_option: true, selected: this.state.currency },
        { label: phrasebook.languages.supported_languages, type: "select", id: "language", name: "language", options: languageOptions, selected: this.state.language },

        { label: phrasebook.profile.address_country, type: "text", placeholder: this.state.address_country, id: "address_country", name: "address_country", value: this.state.address_country },
        { label: phrasebook.profile.address_city, type: "text", placeholder: this.state.address_city, id: "address_city", name: "address_city", value: this.state.address_city },
        { label: phrasebook.profile.address_line_1, type: "text", placeholder: this.state.address_line_1, id: "address_line_1", name: "address_line_1", value: this.state.address_line_1 },
        { label: phrasebook.profile.address_line_2, type: "text", placeholder: this.state.address_line_2, id: "address_line_2", name: "address_line_2", value: this.state.address_line_2 },
        { label: phrasebook.profile.address_line_3, type: "text", placeholder: this.state.address_line_3, id: "address_line_3", name: "address_line_3", value: this.state.address_line_3 },
        { label: phrasebook.profile.address_postcode, type: "text", placeholder: this.state.address_postcode, id: "address_postcode", name: "address_postcode", value: this.state.address_postcode },
      ]
      // // Admin stuff
      // if (token.loggedAccountType() === 100) inputs[0].disabled = false;
      // else inputs[0].disabled = true;


      const buttons = [
        <CancelButton title={phrasebook.common.cancel} link={gisRoutes.dashboard[this.account_type_logged]} />, <SubmitButton title={phrasebook.common.update} />]

      return (
        <Form
          handleSubmit={this.handleSubmit}
          onChange={this.handleChange}
          title={phrasebook.profile.profile}
          inputs={inputs}
          buttons={buttons}
          outform={token.loggedAccountType() == 400 ? <ModalButton label="Delete Account" className="btn btn-faded" /> : null}
        />)
    } else return null;
  }

  render() {
    return <>
      <NewBreadcrumbs crumbs={[{ link: gisRoutes.dashboard[this.account_type_logged], label: phrasebook.common.home }]} current={phrasebook.profile.profile} />

      {this.FormProfile()}
      {token.loggedAccountType() == 400 ? <Modal
        title={"Delete Account"}
        description={"Would you like to delete your account?"}
        confirmInput={
          <div>
            <label for="e-input-3"><strong>Loggin Password<i class="color-categorical-5">*</i></strong><i className="info-icon tooltip tooltip-bottom tooltip-xs-right pl-1" data-tooltip="Introduce your logging password"></i></label>
            <input type="password"
              placeholder="Login Password"
              id="delete_password"
              name="delete_password"
              value={this.state.delete_password}
              onChange={this.handleChange}
              required /></div>}
        cancelLabel={phrasebook.common.cancel}
        confirmLabel={phrasebook.common.confirm}
        onClick={this.handleDelete}
      /> : null}
    </>
  }
}

function mapStateToProps(state) {
  const { account, customer, authentication, georesource } = state;
  const { authUser } = authentication;
  return {
    authUser,
    customers: customer.customers,
    currencies: georesource.currencies,
    userprofile: account.userprofile
  };
}

const userProfile = connect(mapStateToProps)(UserProfile);

export default (userProfile);
